const ABOUTUS_PATHS = {
    "about-us": {
        "it": "chi-siamo",
        "de": "filo-ueber-uns",
        "es": "filo-about-us",
        "fr": "filo-about-us",
        "en": "about-us"
    },
    "chi-siamo": {
        "it": "chi-siamo",
        "de": "filo-ueber-uns",
        "es": "filo-about-us",
        "fr": "filo-about-us",
        "en": "about-us"
    },
    "filo-about-us": {
        "en": "about-us",
        "it": "chi-siamo",
        "de": "filo-ueber-uns",
        "fr": "filo-about-us",
        "es": "filo-about-us",
    },
    "filo-ueber-uns": {
        "it": "chi-siamo",
        "de": "filo-ueber-uns",
        "es": "filo-about-us",
        "fr": "filo-about-us",
        "en": "about-us"
    }
}

export default ABOUTUS_PATHS;